import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { lastValueFrom, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export abstract class Factory {

    protected http: HttpClient = inject(HttpClient);
    protected baseUrl: string = environment.apiUrl;
    protected abstract url: string;

    constructor() {}

    protected get<T>(endpoint?: string, queryParams?: Record<string, any>): Promise<T> {
        
        let params = new HttpParams();
        if (queryParams) {
            Object.keys(queryParams).forEach(key => {
                if (queryParams[key] !== undefined && queryParams[key] !== null) {
                    params = params.set(key, queryParams[key]);
                }
            });
        }

        return lastValueFrom(
            this.http.get<T>(`${this.baseUrl}/${this.url}${endpoint ? `/${endpoint}` : ''}`, {
                params: queryParams ? params : undefined 
            })
        );

    }

    protected post<T>(endpoint: string, body: any): Promise<T> {
        return lastValueFrom(this.http.post<T>(`${this.baseUrl}/${this.url}/${endpoint}`, body));
    }

    protected put<T>(endpoint: string, body: any): Promise<T> {
        return lastValueFrom(this.http.put<T>(`${this.baseUrl}/${this.url}/${endpoint}`, body));
    }

    protected delete<T>(endpoint: string): Promise<T> {
        return lastValueFrom(this.http.delete<T>(`${this.baseUrl}/${this.url}/${endpoint}`));
    }

}
